import SignContainer from "../../../../components/basic/SignContainer";
import {
    ContentDetailInfoShell,
    ContentDetailThreeColLayout,
    DetailKvListValue,
    KV_LIST_TYPES,
    DetailPanel,
    DetailKvTable,
    DetailFilePanel,
    DetailSummaryPrintButton,
} from "../../../../components/detailLayout";
import Th_title from "../../../../components/Th_title";
import ReadOnlyInputBasic from "../../../../components/input/ReadOnlyInputBasic";
import {inspectionRequestCode} from "../InspectionCreate";
import React, {useEffect, useState} from "react";
import {removeInspectionReport} from "../../../../api/maintenance/InspectionService";
import SimmsDatePicker from "../../../../components/datepicker/SimmsDatePicker";
import InspectionReportItem from "./InspectionReportItem";
import InspectionReportAssetItem from "./InspectionReportAssetItem";
import {ContentCategory} from "../../../../constant/CodeSpecNum";

function InspectionReportView({inspection, assets, handler, statusNumericValue, inspectionReport, setInspectionReport}){
    const [view, setView] = useState();

    useEffect(() => {
        const settings = localStorage.getItem("setting");
        setView(JSON.parse(settings)?.find(e => e.globalsNmAsSnake === "inspectionReport")?.globalsValue === "true")
    }, [])

    const remove = async () =>{
        const response = await removeInspectionReport({id: inspectionReport.id});
        if (response.status === 200) {
            setInspectionReport({});
            alert("점검보고서가 정상적으로 삭제되었습니다.");
        }
    }

    const movePage={
        url:"/maintenance/inspection/report/update/"+inspection.id,
        content : "수정페이지"
    }

    const summaryMeta = [
        inspection.inspectCode?.name && `코드 ${inspection.inspectCode.name}`,
        inspection.requester?.name && `요청 ${inspection.requester.name}`,
    ].filter(Boolean).join(" · ");

    if(Object.keys(inspectionReport).length > 0) {
        const requestInfoPanel = (
            <DetailPanel title={"점검요청정보"}>
                <DetailKvTable>
                    <tbody>
                        <tr>
                            <Th_title title={"자산목록"} colspan={3} className="fieldset-td relative align-top">
                                <DetailKvListValue items={assets} listType={KV_LIST_TYPES.asset} />
                            </Th_title>
                        </tr>
                        <tr>
                            <Th_title title={"등록일시"} colspan={1} className="fieldset-td">
                                <ReadOnlyInputBasic target={"createdAt"} value={inspection.createdAt} />
                            </Th_title>
                            <Th_title title={"등록자"} colspan={1} className="fieldset-td">
                                <ReadOnlyInputBasic target={"createdBy"} value={inspection.createdBy} />
                            </Th_title>
                        </tr>
                        <tr>
                            <Th_title title={"수정일시"} colspan={1} className="fieldset-td">
                                <ReadOnlyInputBasic target={"updatedAt"} value={inspection.updatedAt} />
                            </Th_title>
                            <Th_title title={"수정자"} colspan={1} className="fieldset-td">
                                <ReadOnlyInputBasic target={"updatedBy"} value={inspection.updatedBy} />
                            </Th_title>
                        </tr>
                        <tr>
                            <Th_title title={"점검 제목"} colspan={3} className="fieldset-td">
                                <ReadOnlyInputBasic target={"title"} value={inspection.title} />
                            </Th_title>
                        </tr>
                        <tr>
                            <Th_title title={"요청자"} colspan={3} className="fieldset-td">
                                <ReadOnlyInputBasic target={"requester"} value={inspection.requester} />
                            </Th_title>
                        </tr>
                        <tr>
                            <Th_title title={"담당자"} colspan={3} className="fieldset-td fieldset-td-input relative align-top">
                                <DetailKvListValue items={handler} listType={KV_LIST_TYPES.user} />
                            </Th_title>
                        </tr>
                        <tr>
                            <Th_title title={"점검코드"} colspan={1} className="fieldset-td">
                                <ReadOnlyInputBasic target={"inspectCode"} value={inspection.inspectCode?.name} />
                            </Th_title>
                            <Th_title title={"요청방식"} colspan={1} className="fieldset-td">
                                <ReadOnlyInputBasic target={"requestCode"} value={ inspectionRequestCode.find(data => data.id === inspection.requestCode) } />
                            </Th_title>
                        </tr>
                        <tr>
                            <Th_title title={"점검기간"} colspan={3} className="fieldset-td fieldset-td-input">
                                <div className="web-flex asset-detail-date-range">
                                    <SimmsDatePicker data={inspection.inspectStartDate} readonly />
                                    <span className="asset-detail-date-range-sep">~</span>
                                    <SimmsDatePicker data={inspection.inspectEndDate} readonly />
                                </div>
                            </Th_title>
                        </tr>
                    </tbody>
                </DetailKvTable>
            </DetailPanel>
        );

        const reportContentPanels = (
            <>
                <DetailPanel title={"점검내용"}>
                    <DetailKvTable>
                        <tbody>
                            <tr>
                                <Th_title title={"점검결과"} colspan={3} className="fieldset-td" auth={inspection.auth.update}>
                                    <div className={`align-text-div`}>{inspectionReport.inspectionResult}</div>
                                </Th_title>
                            </tr>
                            <tr>
                                <Th_title title={"코드 구분"} colspan={3} className="fieldset-td" required={true}>
                                    <ReadOnlyInputBasic target={"inspectionReportCode"} value={inspectionReport.inspectionReportCode.reportCode == "company" ? "협력 업체별" : "자산 그룹별"} />
                                </Th_title>
                            </tr>
                            <tr>
                                <Th_title title={"코드명"} colspan={3} className="fieldset-td">
                                    <ReadOnlyInputBasic target={"name"} value={inspectionReport.inspectionReportCode.name} />
                                </Th_title>
                            </tr>
                        </tbody>
                    </DetailKvTable>
                </DetailPanel>

                <InspectionReportItem view={view} obj={inspectionReport} status={"view"} setter={setInspectionReport} />
                <InspectionReportAssetItem view={view} obj={inspectionReport} status={"view"} asset={assets} setter={setInspectionReport} />
            </>
        );

        const filePanel = (
            <>
                <SignContainer contentId={inspection.id} contentCategory={"INSPECTION"} statusNumericValue={statusNumericValue} />
                <DetailFilePanel
                    isEditing={false}
                    showFileLabel={false}
                    tableInfo={{tableName: "inspection_report", joinKey: inspectionReport.id}}
                />
            </>
        );

        return (
            <ContentDetailInfoShell
                title={inspection?.title || "점검보고서"}
                meta={summaryMeta || inspection?.serialNumber}
                contentId={inspection.id}
                contentCategory={ContentCategory.INSPECTION}
                scrollMode="columns"
                listUrl="/maintenance/inspection"
                actions={<DetailSummaryPrintButton />}
                rollup={{
                    remove: inspection.auth?.update && remove,
                    movePage: inspection.auth?.update && movePage,
                }}
            >
                <ContentDetailThreeColLayout
                    primary={requestInfoPanel}
                    secondary={reportContentPanels}
                    aside={filePanel}
                />
            </ContentDetailInfoShell>
        )
    }
}

export {InspectionReportView}
